function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.52393 22.1645C5.0407 25.8535 6.81434 30.0524 10.4855 31.5429L15.8568 18.1835C12.1856 16.6931 8.00717 18.4754 6.52393 22.1645Z",
  fill: "url(#paint0_linear_52518_36972)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.454 24.6801C13.7589 28.8962 15.7859 33.6949 19.9815 35.3983C24.1771 37.1017 28.9524 35.0648 30.6476 30.8487L15.454 24.6801Z",
  fill: "url(#paint1_linear_52518_36972)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5922 6C34.8367 8.12927 37.3704 14.1277 35.2515 19.3978C33.1326 24.6679 27.1634 27.2141 21.9189 25.0848L29.5922 6Z",
  fill: "url(#paint2_linear_52518_36972)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9265 13.9618C12.1978 10.7998 15.7794 9.27206 18.9261 10.5496C22.0728 11.8272 23.593 15.4262 22.3217 18.5883L10.9265 13.9618Z",
  fill: "url(#paint3_linear_52518_36972)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45 32.5731V9H54.258C57.4671 9 60.1401 10.1483 62.2552 12.4429C64.3888 14.7117 65.4535 17.4992 65.4535 20.7866C65.4535 24.0744 64.3885 26.8726 62.2552 29.1631C60.1397 31.4361 57.4666 32.5731 54.258 32.5731H45ZM73.052 28.5659C74.066 29.3311 75.3144 29.7209 76.8149 29.7209C78.899 29.7209 80.3713 28.9599 81.294 27.463L81.4424 27.2223L84.3883 28.8944L84.2199 29.1552C82.562 31.7214 80.0559 33 76.7492 33C74.0778 33 71.8767 32.1668 70.1726 30.4855L70.1698 30.4827C68.491 28.7812 67.6553 26.6362 67.6553 24.0704C67.6553 21.5269 68.4797 19.3936 70.1356 17.6923C71.7952 15.9873 73.943 15.1407 76.5521 15.1407C79.0382 15.1407 81.079 16.0262 82.6485 17.7996C84.2316 19.5417 85.0221 21.6485 85.0221 24.1032C85.0221 24.5346 84.988 24.9761 84.9203 25.4274L84.8828 25.6771H71.2358C71.5413 26.9124 72.149 27.8693 73.052 28.5659ZM72.9325 19.6638C72.0637 20.4005 71.4929 21.3724 71.2259 22.595H81.4897C81.2252 21.2645 80.661 20.2646 79.8139 19.5681C78.8829 18.8027 77.8 18.4199 76.5521 18.4199C75.0793 18.4199 73.8811 18.839 72.9353 19.6614L72.9325 19.6638ZM112.512 32.5731H109.069V22.1658C109.069 20.9459 108.754 20.0414 108.163 19.4109C107.57 18.7779 106.776 18.4527 105.75 18.4527C104.598 18.4527 103.696 18.8396 103.013 19.6027C102.359 20.3361 102.004 21.4992 102.004 23.1509V32.5731H98.5608V22.1658C98.5608 20.9434 98.2557 20.0376 97.6844 19.4072L97.6827 19.4053L97.681 19.4034C97.1325 18.7765 96.3756 18.4527 95.3731 18.4527C94.2456 18.4527 93.3158 18.8385 92.5634 19.6105C91.8471 20.3677 91.463 21.5295 91.463 23.1509V32.5731H88.0197V15.5676H91.463V17.1663C92.6025 15.8176 94.1437 15.1407 96.0627 15.1407C97.21 15.1407 98.2177 15.3824 99.0746 15.8779C99.8056 16.3006 100.415 16.9009 100.904 17.6704C102.096 15.9846 103.822 15.1407 106.046 15.1407C107.955 15.1407 109.524 15.7689 110.724 17.0377C111.926 18.2869 112.512 19.9752 112.512 22.0672V32.5731ZM120.664 28.5659C121.678 29.3311 122.927 29.7209 124.427 29.7209C126.511 29.7209 127.984 28.9599 128.906 27.463L129.055 27.2223L132.001 28.8944L131.832 29.1552C130.174 31.7214 127.668 33 124.362 33C121.69 33 119.489 32.1668 117.785 30.4855L117.782 30.4827C116.103 28.7812 115.268 26.6362 115.268 24.0704C115.268 21.5269 116.092 19.3936 117.748 17.6923C119.408 15.9873 121.555 15.1407 124.165 15.1407C126.651 15.1407 128.692 16.0262 130.261 17.7997C131.844 19.5418 132.635 21.6486 132.635 24.1032C132.635 24.5346 132.6 24.9761 132.533 25.4274L132.495 25.6771H118.848C119.154 26.9124 119.761 27.8693 120.664 28.5659ZM120.548 19.6614L120.545 19.6638C119.676 20.4005 119.105 21.3724 118.838 22.595H129.102C128.838 21.2645 128.273 20.2646 127.426 19.5681C126.495 18.8027 125.412 18.4199 124.165 18.4199C122.692 18.4199 121.494 18.839 120.548 19.6614ZM149.989 32.5731H145.91L141.46 26.5649L136.978 32.5731H132.896L139.42 23.8402L133.258 15.5676H137.372L141.461 21.0824L145.549 15.5676H149.63L143.501 23.8081L149.989 32.5731ZM54.258 29.097C56.523 29.097 58.3579 28.3071 59.7875 26.7304C61.2219 25.1483 61.9445 23.174 61.9445 20.7866C61.9445 18.3991 61.2219 16.4248 59.7875 14.8428C58.3579 13.266 56.523 12.4762 54.258 12.4762H48.6403V29.097H54.258Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52518_36972",
  x1: 36,
  y1: 21,
  x2: 6,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_52518_36972",
  x1: 36,
  y1: 21,
  x2: 6,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_52518_36972",
  x1: 36,
  y1: 21,
  x2: 6,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_52518_36972",
  x1: 36,
  y1: 21,
  x2: 6,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgDemexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 42,
    viewBox: "0 0 156 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemexLogo);
export default __webpack_public_path__ + "static/media/DemexLogo.907bc08840cb79c69fa4bed6720e3bbf.svg";
export { ForwardRef as ReactComponent };